import { fetchCategories } from '@/api/programs';

import category from './category';

function cleanCategory({
  id, name, slug, description,
}) {
  return {
    id,
    slug,
    name,
    description,
  };
}

export default {
  namespaced: true,
  state() {
    return [];
  },
  actions: {
    // fetchHero({ state, dispatch }) {
    //   state.forEach((_, index) => {
    //     dispatch(`${index}/hero/fetch`);
    //   });
    // },
    async fetch({ commit }) {
      (await fetchCategories()).map(cleanCategory).forEach(({
        id, slug, name, description,
      }, index) => {
        this.registerModule(['categories', index.toString()], category);

        commit(`${index}/setId`, id);
        commit(`${index}/setSlug`, slug);
        commit(`${index}/setName`, name);
        commit(`${index}/setDescription`, description);
      });
    },
  },
};
